import styled from '@emotion/styled'
import { color } from 'styled-system'
import { theme } from '../../../theme'

export const DateRangePickerWrapper = styled.div`
  .DateRangePickerInput {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    border-radius: 50px;
  }
  .DateInput {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50px;
    width: 40%;
  }
  .DateInput__focused {
    border: none;
  }
  .DateRangePickerInput_arrow {
    width: 10%;
  }
  .DateInput_input {
    border-radius: 50px;
    border: none;
    height: 40px;
    font-size: 12px;
    font-weight: 275;
  }
  @media only screen and (max-width: 768px) {
    .DateInput_input {
      font-size: 16px;
    }
  }
  .DateRangePickerInput_input {
    ${color};
    display: flex;
    font-weight: 400;
    border-radius: 4px;
    font-style: normal;
    width: 100%;
    display: flex;
    align-items: center;
    position: relative;
    transition: all 0.2s;
    outline: none;
    font-size: 1rem;
    padding-left: 1rem;
    padding-right: 1rem;
    height: 2.5rem;
    line-height: 2.5rem;
    border-radius: 50px;
    border-width: 0;
    border-color: inherit;
    background-color: #fff;
    &:hover {
      border-color: ${theme.colors.gray[300]};
    }
    &:disabled {
      opacity: 0.5;
    }
  }
  .DateInput_input__focused {
    border: none;
  }
  .CalendarDay__selected,
  .CalendarDay__selected:active,
  .CalendarDay__selected:hover {
    background: ${theme.colors.brand[500]};
    border: 1px double ${theme.colors.brand[500]};
    color: #fff;
  }
  .SingleDatePicker {
    display: flex;
  }
  .SingleDatePicker_picker {
    z-index: 1700;
  }
  .SingleDatePicker > div,
  .SingleDatePicker > div > .SingleDatePickerInput {
    width: 100%;
    border-radius: 50px;
  }
  .DateRangePickerInput__withBorder {
    border: none;
    height: 40px;
  }
  .CalendarMonth_caption {
    padding-top: 16px;
  }
`
